import { render } from "./PurchaseOrderAIPrompts.vue?vue&type=template&id=9b7bc9ba&ts=true"
import script from "./PurchaseOrderAIPrompts.vue?vue&type=script&lang=ts"
export * from "./PurchaseOrderAIPrompts.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__